module.exports = __webpack_public_path__ + "static/media/copy.6a1d76e4.svg";